import { useState } from 'react'
import { Tooltip } from '@arco-design/web-react'
import { IconCopy, IconCheck } from '@arco-design/web-react/icon'
import useLocale from '@/utils/useLocale'

interface CopyProps {
  text: string
}

export default function Copy({ text }: CopyProps) {
  const t = useLocale()
  const [isCopied, setIsCopied] = useState(false)
  const [isError, setIsError] = useState(false)
  const successMessage = t['product.detail.copySuccess']
  const errorMessage = t['product.detail.copyError']

  const handleCopy = async () => {
    try {
      // 检查是否支持 clipboard API
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text)
      } else {
        // 降级方案：使用传统的 execCommand
        const textArea = document.createElement('textarea')
        textArea.value = text
        textArea.style.position = 'fixed'
        textArea.style.left = '-999999px'
        textArea.style.top = '-999999px'
        document.body.appendChild(textArea)
        textArea.focus()
        textArea.select()
        document.execCommand('copy')
        document.body.removeChild(textArea)
      }

      setIsCopied(true)
      setIsError(false)

      // 2秒后重置状态
      setTimeout(() => {
        setIsCopied(false)
      }, 2000)
    } catch (err) {
      console.error('复制失败:', err)
      setIsError(true)
      setIsCopied(false)

      // 3秒后重置错误状态
      setTimeout(() => {
        setIsError(false)
      }, 3000)
    }
  }

  const getTooltipContent = () => {
    if (isCopied) return successMessage
    if (isError) return errorMessage
    return t['tool.ai.detail.copy']
  }

  return (
    <Tooltip content={getTooltipContent()}>
      <span className="cursor-pointer" onClick={handleCopy}>
        {isCopied ? <IconCheck className="text-green-600" /> : <IconCopy />}
      </span>
    </Tooltip>
  )
}
